import { RootState } from "index";

export const selectIndicators = (state: RootState) => state.indicators